import { useDocumentsRepository } from '@Hooks/useRepository';
import { type EnumPlaceholderKinds } from '@Model';
import { PlaceholdersRepository } from '@Repositories/Documents';
import { unwrapOr } from '@synqo/frontend-component-library';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

export function useGetDocumentsPlaceholders(placeholdersKind: EnumPlaceholderKinds) {
    const placeholders = useDocumentsRepository(PlaceholdersRepository);

    const query = useQuery({
        queryFn: () => placeholders.getPlaceholders(placeholdersKind),
        queryKey: ['documents', 'placeholders', placeholdersKind],
    });

    return useMemo(
        () => ({
            placeholders: unwrapOr(query.data, []),
            isLoading: query.isLoading,
        }),
        [query.data, query.isLoading],
    );
}
